'use client';

import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';
import TradePageTable from 'src/components/TradePageTable/TradePageTable';
import PortfolioFeeTierCard from 'src/components/PortfolioPage/PortfolioTradeSubPage/PortfolioFeeTierCard';
import PortfolioTradeSubPageChart from 'src/components/PortfolioPage/PortfolioTradeSubPage/PortfolioTradeSubPageChart';
import PortfolioPerformanceStats from 'src/components/PortfolioPage/PortfolioTradeSubPage/PortfolioPerformanceStats';
import { PORTFOLIO_DEFAULT_PERIOD } from 'src/components/PortfolioPage/consts';

export default function PortfolioTradeSubPage() {
	const [period, setPeriod] = useSyncLocalStorage(
		'portfolioPeriod',
		PORTFOLIO_DEFAULT_PERIOD
	);
	const [includeFeesAndFunding, setIncludeFeesAndFunding] = useSyncLocalStorage(
		'portfolioIncludeFeesAndFunding',
		true
	);
	const [realizedPnlOnly, setRealizedPnlOnly] = useSyncLocalStorage(
		'portfolioRealizedPnlOnly',
		false
	);

	return (
		<div className="grid grid-cols-12 gap-md sm:gap-lg">
			<div className="col-span-12 flex flex-col gap-y-md sm:col-span-5 sm:gap-y-lg">
				<PortfolioPerformanceStats
					period={period}
					setPeriod={setPeriod}
					includeFeesAndFunding={includeFeesAndFunding}
					realizedPnlOnly={realizedPnlOnly}
				/>

				<PortfolioFeeTierCard />
			</div>

			<PortfolioTradeSubPageChart
				period={period}
				includeFeesAndFunding={includeFeesAndFunding}
				realizedPnlOnly={realizedPnlOnly}
				setIncludeFeesAndFunding={setIncludeFeesAndFunding}
				setRealizedPnlOnly={setRealizedPnlOnly}
			/>

			<TradePageTable
				className="col-span-12 not-sm:-mx-md sm:min-h-88"
				overviewPage
			/>
		</div>
	);
}
